import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';

@Component({
  selector: 'app-enetassess',
  templateUrl: './enetassess.component.html',
  styleUrls: ['./enetassess.component.scss']
})
export class EnetassessComponent implements OnInit {

  public logo = "";

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService
  ) { 
    this.logo = "https://www.iwcf.org/wp-content/uploads/2018/12/iwcflogo.png";

    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0) {
      generalSvc.logoutUser();
    }

    if (dataSvc.currentUser.Exams.filter(x => x.Completed != true).length == 0)
      generalSvc.logoutUser();
  }

  ngOnInit() {
  }

  launchExam(examIndex) {
    this.dataSvc.currentExamIndex = examIndex;
    this.dataSvc.pulseTimeLog("Start");
    this.generalSvc.launchExam();
  }

  logout(){
    this.generalSvc.logoutUser();
  }
}